import React, { useState, useEffect } from 'react'
import { Modal } from 'antd'
import parse from 'html-react-parser'
import { getNotices } from './actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import css from './index.scss'

const DailyAlertModal = ({ fetchNotices, ad, location, ...props }) => {
  const [visible, setVisible] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const modalShownToday = localStorage.getItem('modalShownToday') === new Date().toLocaleDateString()

  const onCancel = () => {
    localStorage.setItem('modalShownToday', new Date().toLocaleDateString())
    setVisible(false)
  }
  useEffect(() => {
    if (!modalShownToday && !ad.length) {
      fetchNotices()
    }
  }, [modalShownToday, ad.length])

  useEffect(() => {
    function showModal() {
      setVisible(true)
    }
    if (!modalShownToday && ad.length > 0) {
      showModal()
    }
  }, [modalShownToday, location.pathname, ad.length])

  const handleNextAnnounce = () => setSelectedIndex(prev => prev + 1)
  const handlePrevAnnounce = () => setSelectedIndex(prev => prev - 1)

  return (
    <Modal
      footer={null}
      visible={visible}
      className={css.modal}
      closable={false}
      width={900}
      bodyStyle={{
        padding: 0,
        minHeight: 500,
      }}
      wrapClassName={
        css.wrap
      }
    >
      {ad.map((item, index) => {
        if (selectedIndex === index) {
          return (
            <div className={css.container} key={item.title}>
              <div className={css.header}>{item.announcedBy} informa</div>
              <div className={css.body}>
                <p className={css.title}>{item.title}</p>
                <div className={css.contentWrapper}>
                  {parse(item.content)}
                </div>
              </div>
              <div className={css.footer}>
                {selectedIndex > 0 &&
                <button className={css.prevButton} onClick={handlePrevAnnounce}>Voltar</button>
                }
                {selectedIndex < (ad.length - 1) &&
                <button className={css.nextButton} onClick={handleNextAnnounce}>Próximo</button>
                }
                {selectedIndex === (ad.length - 1) &&
                <button className={css.nextButton} onClick={onCancel}>Fechar</button>
                }
              </div>
            </div>
          )
        }
        return null
      },
      )}

    </Modal>
  )
}

const mapStateToProps = state => ({
  ad: state.notices.ad,
})

const mapActionsToProps = dispatch => ({
  fetchNotices() {
    dispatch(getNotices())
  },
})
export default withRouter(connect(mapStateToProps, mapActionsToProps)(DailyAlertModal))

